import { useModuleEndpoint } from './useModuleEndpoint';
export function useModuleConfig(moduleId, subpath = '') {
    const { response: moduleConfig = {}, getEndpoint: fetchModuleConfig, reset: resetConfig, isFetching, hasJustFinishedFetching, error: configError } = useModuleEndpoint(moduleId, `${subpath}/config`);
    const { response: saveResponse = {}, postEndpoint: saveModuleConfig, isFetching: isSaving, hasJustFinishedFetching: hasJustFinishedSaving, error: saveError } = useModuleEndpoint(moduleId, `${subpath}/save`);
    return {
        error: saveError || configError,
        isSaving,
        isFetching,
        moduleConfig,
        saveResponse,
        resetConfig,
        saveModuleConfig,
        fetchModuleConfig,
        hasJustFinishedFetching,
        hasJustFinishedSaving
    };
}
export default useModuleConfig;
